// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_bo-0";